export const iconFontAwesomeHumanitarianStaffSnake = (
	<i className="fa-solid fa-staff-snake"></i>
);
